import styled, { CSSObject } from 'styled-components';

export const FormLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 32px;
`;

export const FormStructure = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Input = styled.input`
  padding: 8px;
`;

export const FormLabel = styled.div`
  color: black;
`;

export const FormElement = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const selectStyles = {
  option: (provided: CSSObject) => ({
    ...provided,
    color: 'black',
  }),
};
